import { render, staticRenderFns } from "./NlcrTable.vue?vue&type=template&id=f2d2778c"
import script from "./NlcrTable.vue?vue&type=script&lang=ts"
export * from "./NlcrTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports